import { userPermissionsEnum } from '../enums/user-permissions.enum';
import { AccountModel } from './account.model';
import { UserModel } from './user.model';
import { PreferencesModel } from './preferences.model';
import { UserAccountApiModel } from '../../../api/users/models/user-account.api.model';

export class UserAccountModel {
    user: UserModel;
    account: AccountModel;
    preferences: PreferencesModel;
    permissions: userPermissionsEnum[];

    constructor(apiEntity?: UserAccountApiModel, accountUsersEntity?: UserAccountModel[]) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity, accountUsersEntity);
        } else {
            this.constructDefault();
        }
    }

    public hasPermission(permission: userPermissionsEnum): boolean {
        const hasCurrentUserPermission: boolean = this.permissions.includes(permission);

        return hasCurrentUserPermission;
    }

    /**
     * Constructs this model based on the provided api entity
     */
    private constructFromApiEntity(apiEntity: UserAccountApiModel, accountUsersEntity: UserAccountModel[]): void {
        this.user = new UserModel(apiEntity.user);
        this.account = new AccountModel(apiEntity.account);
        this.account.users = accountUsersEntity?.map((user: any) => new UserModel(user)) || [];
        this.preferences = new PreferencesModel(apiEntity.preferences);
        this.permissions = [...apiEntity.permissions];
    }

    /**
     * Constructs the default version of this model
     */
    protected constructDefault(): void {
        this.user = new UserModel();
        this.account = new AccountModel();
        this.preferences = new PreferencesModel();
        this.permissions = [];
    }
}
